module.exports = __webpack_public_path__ + "static/media/user-illustration.9576f88d.svg";